import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';

export const StyledLink = styled(Link, {
  fontSize: '15px !important',
});
